import { render, staticRenderFns } from "./CcMethodChip.vue?vue&type=template&id=dfae1166&scoped=true"
import script from "./CcMethodChip.vue?vue&type=script&setup=true&lang=js"
export * from "./CcMethodChip.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CcMethodChip.vue?vue&type=style&index=0&id=dfae1166&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfae1166",
  null
  
)

export default component.exports